import styled from 'styled-components'

import { ReactComponent as SketchLogoBlackUnstyled } from '@sketch/icons/logo-black-svg'
import ModalUnstyled from 'components/Modal'
import { breakpoint } from '@sketch/global-styles'

import background1x from '@sketch/icons/modal-diamond@1x.png'
import background2x from '@sketch/icons/modal-diamond@2x.png'

export const Text = styled.p`
  display: inline;
  font-size: small;
  color: ${({ theme }) => theme.colors.foreground.secondary.C};
`

export const SketchLogoBlack = styled(SketchLogoBlackUnstyled)`
  width: 14px;
  height: 14px;
  /* stylelint-disable scales/space */
  margin: 0 0 0 2px;
`

export const SketchLogoText = styled.span`
  font-weight: 700;
  font-size: ${({ theme }) => theme.fontSizes.E};
`

// TODO: Unify highlight / diamond modal component
//  see: https://github.com/sketch-hq/Cloud/issues/15125
export const Modal = styled(ModalUnstyled)`
  background-color: ${({ theme }) => theme.colors.brand.green.default.A};
  background-position: right -120px center;

  /* stylelint-disable value-no-vendor-prefix */
  background-image: -webkit-image-set(
    url(${background1x}) 1x,
    url(${background2x}) 2x
  );
  /* stylelint-enable value-no-vendor-prefix */

  background-repeat: no-repeat;

  ${breakpoint('sm')`
    background-position: right -50px center;
  `}

  ${ModalUnstyled.Footer} {
    background: transparent;
  }

  ${ModalUnstyled.Header} {
    background: transparent;
  }
`
